import { ArrowDown, DoorOpen } from "lucide-react";
import { motion } from "framer-motion";

function Hero() {
  const enterMuseum = () => {
    document.getElementById("gallery")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section className="relative overflow-hidden px-5 py-20 sm:py-24 lg:px-8 lg:py-28">
      <div className="mx-auto grid w-full max-w-7xl items-center gap-14 lg:grid-cols-[0.95fr_1.05fr]">
        <motion.div initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} className="max-w-3xl">
          <p className="mb-5 text-xs uppercase tracking-[0.35em] text-museum-gold">Every fear is a room</p>
          <h1 className="font-display text-5xl leading-[1.02] text-balance text-museum-bone sm:text-6xl lg:text-7xl">
            Museum of Human Fears
          </h1>
          <p className="mt-6 max-w-2xl text-lg leading-8 text-museum-muted sm:text-xl">
            A quiet digital exhibition about the fears we carry, hide, name, and misunderstand.
          </p>
          <div className="mt-9 flex flex-col gap-3 sm:flex-row">
            <button
              type="button"
              onClick={enterMuseum}
              className="inline-flex items-center justify-center gap-3 rounded-full bg-museum-bone px-6 py-3 text-sm font-semibold text-museum-black transition hover:bg-white"
            >
              <DoorOpen size={18} aria-hidden="true" />
              Enter the Museum
            </button>
            <button
              type="button"
              onClick={enterMuseum}
              className="inline-flex items-center justify-center gap-3 rounded-full border border-museum-bone/20 px-6 py-3 text-sm font-semibold text-museum-bone transition hover:border-museum-gold/70 hover:text-museum-gold"
            >
              <ArrowDown size={18} aria-hidden="true" />
              View the Gallery
            </button>
          </div>
        </motion.div>
        <motion.div initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 1 }} className="relative min-h-[440px] overflow-hidden rounded-lg soft-border bg-black/30 shadow-museum">
          <div className="absolute inset-x-0 top-0 mx-auto h-full w-1/2 spotlight opacity-70" />
          <div className="absolute bottom-0 left-1/2 h-[78%] w-[34%] -translate-x-1/2 border-x border-t border-museum-gold/35 bg-gradient-to-b from-museum-bone/8 to-museum-black shadow-glow">
            <div className="absolute left-1/2 top-1/2 h-3 w-3 -translate-y-1/2 rounded-full bg-museum-gold/50" />
          </div>
          <div className="absolute left-[8%] top-[25%] h-24 w-16 border border-museum-bone/10 bg-museum-panel/40" />
          <div className="absolute right-[11%] top-[32%] h-20 w-14 border border-museum-bone/10 bg-museum-panel/30" />
          <div className="absolute left-[18%] bottom-[22%] h-16 w-24 border border-museum-bone/10 bg-museum-panel/30" />
          <div className="absolute right-[21%] bottom-[18%] h-20 w-16 border border-museum-bone/10 bg-museum-panel/35" />
          <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-museum-black via-museum-black/80 to-transparent" />
          <div className="fog-layer opacity-80" />
          <div className="absolute inset-0">
            {Array.from({ length: 34 }).map((_, index) => (
              <span
                key={index}
                className="absolute h-1 w-1 rounded-full bg-museum-bone/30"
                style={{
                  left: `${(index * 17) % 96}%`,
                  top: `${18 + ((index * 29) % 68)}%`,
                  opacity: 0.18 + ((index % 5) * 0.08)
                }}
              />
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}

export default Hero;
